import { formatInTimeZone } from "date-fns-tz";

const TZ = "Australia/Sydney";

export function formatMoney(cents: number): string {
  const negative = cents < 0;
  const abs = Math.abs(cents);
  const dollars = (abs / 100).toFixed(2);
  const [whole, decimal] = dollars.split(".");
  const withCommas = whole!.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${negative ? "-" : ""}$${withCommas}.${decimal}`;
}

export function parseMoneyToCents(input: string): number | null {
  const cleaned = input.replace(/[$,\s]/g, "");
  if (!/^-?\d+(\.\d{1,2})?$/.test(cleaned)) return null;
  return Math.round(Number(cleaned) * 100);
}

export function formatDate(iso: string): string {
  return formatInTimeZone(new Date(iso), TZ, "dd MMM yyyy");
}

export function formatDateTime(iso: string): string {
  return formatInTimeZone(new Date(iso), TZ, "dd MMM yyyy h:mm a")
    .replace("AM", "am")
    .replace("PM", "pm");
}

export function formatNumber(
  n: number,
  options: { fractionDigits?: number } = {},
): string {
  return new Intl.NumberFormat("en-AU", {
    minimumFractionDigits: options.fractionDigits ?? 0,
    maximumFractionDigits: options.fractionDigits ?? 0,
  }).format(n);
}
